"use strict";

var cov_nzp4i5sw7 = function () {
  var path = "/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/cart/lib/model.js",
      hash = "d6789ed2455125aae5f2acaf14f4b67fc927cb2c",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/cart/lib/model.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 18
        },
        end: {
          line: 3,
          column: 1
        }
      },
      "1": {
        start: {
          line: 2,
          column: 15
        },
        end: {
          line: 2,
          column: 19
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 7
          },
          end: {
            line: 2,
            column: 8
          }
        },
        loc: {
          start: {
            line: 2,
            column: 15
          },
          end: {
            line: 2,
            column: 19
          }
        },
        line: 2
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CartModel = (cov_nzp4i5sw7.s[0]++, {
  get: function get(data) {
    cov_nzp4i5sw7.f[0]++;
    cov_nzp4i5sw7.s[1]++;
    return data;
  }
});

exports.default = CartModel;